import axios from 'axios'

class AuthRepository {
  register (data) {
    return axios.post(`${BASE_URL}/users`, data)
    .then(response => {
      return response.data
    })
  }

  login (email, pw) {
    return axios.post(`${BASE_URL}/users/signin`, {
      email: email,
      password: pw
    }).then(response => {
      return response.data
    })
  }

  get (token) {
    return axios.get(`${BASE_URL}/users?token=${token}`)
    .then(response => {
      return response.data
    })
  }

  count () {
    return axios.get(`${BASE_URL}/users/count`)
    .then(response => {
      return response.data
    })
  }

  save (user) {
    const token = localStorage.getItem('sts_token')
    return axios.put(`${BASE_URL}/users/${user.id}`, user, {
      headers: {'Authorization': `Bearer ${token}`}
    })
    .then(response => {
      return response.data
    })
  }

  changePassword (obj) {
    const token = localStorage.getItem('sts_token')
    return axios.put(`${BASE_URL}/changePassword/${obj.id}`, obj, {
      headers: {'Authorization': `Bearer ${token}`}
    })
    .then(response => {
      return response.data
    })
  }

  resetPassword (email) {
    return axios.post(`${BASE_URL}/users/resetpassword`, {email: email})
    .then(response => {
      return response.data
    })
  }
}

export default new AuthRepository()




// WEBPACK FOOTER //
// ./src/data/auth.repository.js